import React from "react";

export type InfiniteListPager = {
    total: number;
    total_page: number;
    last_page: number;
    per_page: number;
    current_page: number;
    order?: string;
    direction?: string;
    custom?: Record<string, number | undefined>;
};

export interface InfiniteListContextValue {
    items: unknown[];
    pager: InfiniteListPager;
    requestedPerPage: number;
    activeFilters: Record<string, unknown>;
    defaultFetcherParams: Record<string, unknown>;
    isLoading: boolean;
    isFetchingNextPage: boolean;
    hasNextPage: boolean;
    hasError: boolean;
    fetchNextPage: () => void;
    changeFetcherParams: (params?: Record<string, unknown>) => void;
    refreshData: () => void;
}

export const DEFAULT_PAGER: InfiniteListPager = {
    total: 0,
    total_page: 1,
    last_page: 1,
    per_page: 12,
    current_page: 1,
};

export const InfiniteListContext = React.createContext<InfiniteListContextValue>({
    items: [],
    pager: DEFAULT_PAGER,
    requestedPerPage: DEFAULT_PAGER.per_page,
    activeFilters: {},
    defaultFetcherParams: {},
    isLoading: false,
    isFetchingNextPage: false,
    hasNextPage: false,
    hasError: false,
    fetchNextPage: () => {},
    changeFetcherParams: () => {},
    refreshData: () => {},
});
